import { useOrganization } from '@clerk/clerk-react';

const readWhitelabel = (metadata: unknown): string | null => {
  if (typeof metadata !== 'object' || metadata === null) return null;
  const value = (metadata as Record<string, unknown>).whitelabel;
  return typeof value === 'string' && value.length > 0 ? value : null;
};

/** Partner slug stamped on the active Clerk org (`publicMetadata.whitelabel`). */
export const useOrgWhitelabel = (): string | null => {
  const { organization } = useOrganization();
  return readWhitelabel(organization?.publicMetadata);
};
